import { FieldWrapper } from '@fukuri-admins/ui/common/Form/FieldWrapper';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@fukuri-admins/ui/common/Form/FormItems';
import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { useController, useFormContext } from 'react-hook-form';
import { OPTION_GROUPS } from './constants';
import styles from './styles.module.scss';

type Props = {
  name: string;
  placeholder?: string;
  label?: string;
  required?: boolean;
};

export const PortalSelect: React.FC<Props> = ({
  name,
  placeholder = 'ポータルアイテムを選択',
  label = 'ポータルアイテム',
  required = false,
}) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <FieldWrapper
      htmlFor={name}
      labelText={label}
      labelType={required ? 'required' : undefined}
      errorMessages={extractErrorMessages(error)}
    >
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          onClear={() => onChange('')}
          hasValue={!!value}
          clearable
          className={!!error ? styles.PortalSelect__TriggerError : undefined}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {OPTION_GROUPS.map(group => (
            <SelectGroup key={group.title}>
              <SelectLabel>{group.title}</SelectLabel>
              {group.items.map(({ value, label, Icon }) => (
                <SelectItem key={value} value={value}>
                  <span className={styles.PortalSelect__Option}>
                    <Icon size='xs' />
                    {label}
                  </span>
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
    </FieldWrapper>
  );
};
